"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = require("../requests/request");
class API {
    /**
     * @returns {Promise<Contest>} The Promise contains either a result or an APIError if rejected
     */
    static get(path, query, signal, apiURL) {
        let apiRequest = new request_1.AuthenticatedRequest('/bpm-analytics/' + path, request_1.HTTPMethod.GET, request_1.APIVersion.v1_0, query);
        apiRequest.abortSignal = signal;
        if (apiURL) {
            apiRequest.overrideAPIUrl = apiURL;
        }
        return apiRequest.send().then((data) => {
            return data.data;
        });
    }
    /**
     * @returns {Promise<Contest>} The Promise contains either a result or an APIError if rejected
     */
    static post(path, query, apiURL) {
        let apiRequest = new request_1.AuthenticatedRequest('/bpm-analytics/' + path, request_1.HTTPMethod.POST, request_1.APIVersion.v1_0, undefined, query);
        if (apiURL) {
            apiRequest.overrideAPIUrl = apiURL;
        }
        return apiRequest.send().then((data) => {
            return data.data;
        });
    }
}
exports.API = API;



//////////////////
// WEBPACK FOOTER
// ./node_modules/bpm-client-api/lib/endpoints/bpm-analytics.js
// module id = 967
// module chunks = 0